var $62195683522880b5$exports = {};
$62195683522880b5$exports = {
    "help": `\u{17D}inynas`,
    "info": `Informacija`
};


export {$62195683522880b5$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
